export default function MessageInput({message, setMessage, wave, currentAccount, connectWallet, setAlertInfo, setData}){
    return(
        <div className="messagebox">
        <textarea
          value={message}
          rows="12"
          placeholder="Enter message..."
          onChange={(e) => {
            setMessage(e.target.value);
          }}
        />
        <button onClick={()=>wave(setAlertInfo, message, setData)}>Wave to me 👋</button>
        {!currentAccount && (
          <button className="waveButton" onClick={connectWallet}>
            Connect Wallet
          </button>
        )}
      </div>
    )
}